import styled, { css } from 'styled-components';

export const Container = styled.div`
    overflow: visible;
    margin-bottom: -0.4rem;

    svg {
        fill: ${(props) => props.color || '#A9B2B1'};

        ${({ stars }) =>
            stars === 5
                ? css`
                      &:nth-of-type(1) {
                          margin-bottom: -0.8rem;
                      }

                      &:nth-of-type(2n) {
                          margin-bottom: -0.3rem;
                      }

                      &:last-of-type {
                          margin-bottom: -0.8rem;
                      }
                  `
                : (stars === 3 || stars === 4) &&
                  css`
                      &:nth-of-type(1) {
                          margin-bottom: -0.3rem;
                      }

                      &:last-of-type {
                          margin-bottom: -0.3rem;
                      }
                  `}
    }
`;
